module.exports = __webpack_public_path__ + "assets/fc68bb1980bfaa0f027935191a070e79.mp3";